module.exports = __webpack_public_path__ + "static/media/pdf.2afde345.svg";